module.exports = __webpack_public_path__ + "static/images/seven.11ovLzO.svg";